import { defineStore } from "pinia";
import { computed } from "vue";
import keycloak, {
  isAuthenticated,
  tokenParsed,
} from "@/application/plugins/keycloak";

interface Profile {
  id: string;
  name: string;
  email: string;
}

export const useAuthStore = defineStore("auth", () => {
  const isLoggedIn = computed(() => isAuthenticated.value);
  const token = computed(() => (isAuthenticated.value ? keycloak.token : null));

  const profile = computed<Profile | null>(() => {
    const claims = tokenParsed.value;
    if (!claims) return null;

    return {
      id: claims.sub ?? "",
      name: claims.name ?? claims.preferred_username ?? "",
      email: claims.email ?? "",
    };
  });

  const login = (redirectUri = `${window.location.origin}/`) =>
    keycloak.login({ redirectUri });

  const logout = (redirectUri = `${window.location.origin}/`) =>
    keycloak.logout({ redirectUri });

  return {
    isLoggedIn,
    token,
    profile,
    login,
    logout,
  };
});
